import loaders from './loaders'
import errors from './errors'


/**
 * Add recucers to this object
 */
const reducerCatalog = {
    loaders,
    errors
}

export default reducerCatalog
